// extracted by mini-css-extract-plugin
module.exports = {"candidateInfo":"geXgT","topInfo":"Zo7X1","infoRow":"AYUxS","infoCol":"zhLaJ"};